import React, { memo } from "react"

import NavBarSuperior from "../NavBarSuperior/NavBarSuperior"
import LeftSideBar from "./LeftSideBar"
import Main from "./Main"
import { OnboardingPagesProvider } from "./context/OnboardingPagesContext"

const PerfilAluno = () => {
  const openPlansModal = window.location.search.includes('openPlanModal')

  return (
    <OnboardingPagesProvider>
      <div>
        <NavBarSuperior />
        <div className="container-fluid" id="perfil">
          <div className="row">
            <div className="col-md-2" id="left-side-bar">
              <LeftSideBar />
            </div>
            <div className="col-md-10" id="main">
              <Main openPlansModal={openPlansModal} />
            </div>
          </div>
        </div>
      </div>
    </OnboardingPagesProvider>
  )
}

export default memo(PerfilAluno)
